import React, { Suspense } from 'react'

import Heading from '@/components/Heading'
import LinkButtonArrow from '@/components/LinkButtonArrow'
import '@/components/Page/Product/ProductsPage/ProductsPage.scss'
import Products from '@/components/Product/Products'
import Sort from '@/components/Sort'
import { ProductType } from '@/types/product'

type Props = {
  nextLink?: boolean
  btnHref?: string | null
  btnText?: string | null
  groupSymbol?: string | null
  bottomComponent?: React.ReactNode
  children: (_: ProductType) => React.ReactNode
}

export const productGroups = ['kit', 'essence', 'serum', 'cream', 'cleansing', 'facial wash', 'special care']

export default async function ProductsPage({
  nextLink = true,
  btnHref = null,
  btnText = null,
  groupSymbol = null,
  bottomComponent = <></>,
  children,
}: Props) {
  let selectedSort = 'All Product'
  let title = 'Product'
  const sortLinks = [
    ...productGroups.map((productGroup) => {
      const name = productGroup
        .split(' ')
        .map((partOfName: string) => `${partOfName.substring(0, 1).toUpperCase()}${partOfName.substring(1)}`)
        .join(' ')
      const path = productGroup.replaceAll(' ', '')
      if (path == groupSymbol) {
        selectedSort = name
        title = `${name} Product`
      }
      return {
        name,
        href: `/products/groups/${path}`,
      }
    }),
  ]

  return (
    <>
      <section className="l-product-productsPage">
        <div className="l-product-productsPage__inner">
          <div className="l-product-productsPage__heding">
            <Heading fontFamily="Goldenbook">{title}</Heading>

            {btnHref && btnText ? (
              <LinkButtonArrow href={btnHref} nextLink={nextLink}>
                {btnText}
              </LinkButtonArrow>
            ) : (
              <>
                <Sort title={selectedSort} links={[{ href: '/products', name: 'All Product' }, ...sortLinks]} />
              </>
            )}
          </div>

          <Suspense fallback={<></>}>
            <Products nextLink={nextLink} groupSymbol={groupSymbol}>
              {(product) => children(product)}
            </Products>
          </Suspense>
        </div>
        {bottomComponent}
      </section>
    </>
  )
}
